module.exports = __webpack_public_path__ + "img/VP-Classic_Overview-E-Drive_1.aabe720e.jpg";